export const convertMillsToDollars = (mills, round = true) => {
  return round ? (Math.round(mills / 10) / 100).toFixed(2) : mills / 1000;
};

export const convertDollarsToMills = (dollars) => {
  return +dollars * 1000;
};

export const convertCentsToDollars = (cents, round = true) => {
  return round ? (cents / 100).toFixed(2) : cents / 100;
};

export const convertDollarsToCents = (dollars) => {
  return +dollars * 100;
};

export const currencyFormat = (num) => {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(num);
};
